/* eslint-disable multiline-ternary */
/* eslint-disable no-nested-ternary */
import React from 'react'
import Image from 'next/image'
import assetLoader from '@utils/internalImageLoader'
import styles from './googleRating.module.scss'

interface RatingProps {
  value: number
}

const RatingPreview = ({ value }: RatingProps) => {
  const range = [1, 2, 3, 4, 5]
  return (
    <div className={styles.googleRatingStars}>
      <div className={styles.ratingPreviewStyle}>
        {range?.map((item: number) =>
          value && (value >= item || value >= item - 0.2) ? (
            <div key={item} className={styles.ratingPreviewItem}>
              <Image
                src={`${assetLoader()}/images/rating-full-star.svg`}
                alt="Google full Rating icon"
                width={24}
                height={24}
                loading="lazy"
              />
            </div>
          ) : value && value >= item - 0.6 ? (
            <div key={item} className={styles.ratingPreviewItem}>
              <Image
                src={`${assetLoader()}/images/rating-half-star.svg`}
                alt="Google half Rating icon"
                width={24}
                height={24}
                loading="lazy"
              />
            </div>
          ) : (
            <div key={item} className={styles.ratingPreviewItem}>
              <Image
                src="https://acko-seo-prod.ackoassets.com/_next_static/images/no-star-rating.svg"
                alt="Google No Rating icon"
                width={24}
                height={24}
                loading="lazy"
              />
            </div>
          )
        )}
      </div>

      <p className={styles.ratingGrade}>{`${value} / 5`}</p>
    </div>
  )
}

export default RatingPreview
